import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { getConfig } from "lib/get-config";

i18next.use(initReactI18next).init({
  lng: getConfig().uilang,
  fallbackLng: "ru",
  interpolation: {
    escapeValue: false,
  },
  resources: {},
});

export async function loadTranslations(lang: string) {
  try {
    const response = await fetch(`./locales/${lang}.json`);
    if (!response.ok) throw new Error(`Failed to load ${lang} translations`);
    const translations = await response.json();

    i18next.addResourceBundle(lang, "translation", translations, true, true);

    return true;
  } catch (error) {
    console.error(`Error loading ${lang} translations:`, error);
    return false;
  }
}

export default i18next;
